// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"ea2c0592","453":"97b90a09"}[chunkId] + ".chunk.js";
};